module.exports = __webpack_public_path__ + "static/img/hatchback-grey.3a46c28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-grey.svg
// module id = bif6
// module chunks = 74